<template>
  <!-- 保单号 -->
  <div class="detailsNumber">
    <!-- 头部 -->
    <div class="numberTh">
      <span class="baodanId">投保意向单编号: {{ rowOrder.orderSn }}</span>
      <div class="NoPay">
        <el-button
          size="small"
          @click="getPayInfo"
          class="defaultColor button14"
          >投保人信息</el-button
        >
      </div>
    </div>
    <!-- 分割线 -->
    <el-divider></el-divider>

    <!--订单 信息 -->
    <table class="tableALL">
      <tr class="rowCLasspad">
        <td>
          <span> 投保意向单状态:</span>
          <span class="font600" :class="orderClolor[rowOrder.orderStatus]">
            {{ setOrderS[rowOrder.orderStatus] }}</span
          >
        </td>
        <td class="paddingLeft">
          <span>投保险种:</span>
          <span class="font400"> {{ rowOrder.insureName }}</span>
        </td>
        <td>
          <span> 承保机构:</span>
          <span class="font400"> {{ rowOrder.insureCompanyName }}</span>
        </td>
      </tr>
      <tr class="rowCLasspad">
        <td>
          <span>投保品种:</span>
          <span class="font400"> {{ cropAllName[cropId] }}</span>
          <!-- <span>00000---暂无字段</span> -->
        </td>
        <td class="paddingLeft">
          <span>预计保费:</span>
          <span class="font400">
            {{
              rowOrder.amountEstimate ? rowOrder.amountEstimate + "元" : "--"
            }}</span
          >
        </td>
        <td>
          <span> 每亩可保产量:</span>
          <span class="font400">
            {{ rowOrder.numPerUnit ? rowOrder.numPerUnit + "斤" : "--" }}</span
          >
        </td>
      </tr>
      <tr class="rowCLasspad">
        <td>
          <span>提交时间:</span>
          <span class="font400">
            {{ rowOrder.orderTime | formatDate("yyyy-MM-dd") }}
          </span>
        </td>
      </tr>
    </table>
    <!-- 分割线 -->
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
  name: "OrderCar",
  props: {
    rowOrder: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      setOrderS: ["", "已提交", "已完成"],
      orderClolor: ["", "greenC", "greenC"],
      // cropAllName: [
      //   "",
      //   "沪软1212",
      //   "松香粳1018",
      //   "银香38",
      //   "南粳46",
      //   "南粳9108",
      // ],
      cropAllName: ["", "", "", "", "南粳46", "", "太安1号"],
      cropId: null,
    };
  },
  created() {
    this.cropId = this.$route.query.cropId;
  },
  methods: {
    // 告诉父组件的打开投保人信息弹出框
    getPayInfo() {
      this.$emit("openUser");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-divider--horizontal {
  background-color: #e5e5e5 !important;
}
.detailsNumber {
  width: 1140px;
  height: 280px;
  margin: 0 auto;
}
.numberTh {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-divider--horizontal {
  background-color: #f5ebdf;
  margin: 20px 0;
}
.baodanId {
  font-size: 20px;
  color: $--color-primary;
}

.font600 {
  font-size: 20px;
  font-weight: 600;
  margin-left: 10px;
}

.font400 {
  font-size: 16px;
  font-weight: 400;
  margin-left: 10px;
  color: #303133;
}
.el-button {
  width: 92px;
  height: 40px;
  padding: 0;
}
.tableALL {
  width: 100%;
  // background-color: yellow;
}
.rowCLasspad {
  line-height: 50px;
  color: #303133;
  display: flex;
  td {
    flex: 1;
  }
}
.flex2Dis {
  flex: 2 !important;
}
.paddingLeft {
  padding-left: 20px;
}
.greenC {
  color: #11d8a0;
}
</style>
